import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-navy-dark text-gray-500 py-8 text-center text-sm" data-id="element-11">
        <div className="max-w-7xl mx-auto px-4" data-id="element-12">
          <p className="mb-3" data-id="element-13">
            &copy; {new Date().getFullYear()} El Código del Crédito. Todos los
            derechos reservados.
          </p>
          <p className="max-w-2xl mx-auto text-xs opacity-60 mb-6" data-id="element-14">
            Descargo de responsabilidad: Los resultados pueden variar. No somos
            una agencia de reparación de crédito, somos una empresa de educación
            financiera. La información proporcionada no constituye asesoramiento
            legal.
          </p>
          <div className="flex items-center justify-center gap-6 text-xs" data-id="element-15">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-400 hover:text-gold transition-colors duration-200" data-id="element-16">
              Privacidad
            </button>
            <span className="text-gray-700" data-id="element-17">·</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-400 hover:text-gold transition-colors duration-200" data-id="element-18">
              Términos
            </button>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-19">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-20">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-cream/50" data-id="element-21">
              <h2 className="font-heading text-xl font-bold text-navy" data-id="element-22">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={() => setActiveModal(null)} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors" data-id="element-23">
                <XIcon className="w-5 h-5 text-gray-500" data-id="element-24" />
              </button>
            </div>

            {/* Content */}
            <div className="overflow-y-auto px-6 py-6 text-sm text-gray-700 leading-relaxed space-y-4" data-id="element-25">
              {activeModal === 'privacy' ? <PrivacyContent data-id="element-26" /> : <TermsContent data-id="element-27" />}
            </div>

            {/* Footer */}
            <div className="px-6 py-4 border-t border-gray-100 bg-cream/30" data-id="element-28">
              <button onClick={() => setActiveModal(null)} className="w-full bg-navy hover:bg-navy-light text-white font-bold py-2.5 rounded-lg transition-colors text-sm" data-id="element-29">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-xs text-gray-400" data-id="element-30">
        Última actualización: Febrero 2026
      </p>

      <h3 className="font-heading font-bold text-navy text-base" data-id="element-31">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-32">
        Recopilamos información personal que nos proporcionas voluntariamente al
        realizar una compra, como tu nombre, dirección de correo electrónico y
        datos de pago. Los pagos son procesados de forma segura a través de
        plataformas de terceros y no almacenamos información de tarjetas de
        crédito en nuestros servidores.
      </p>

      <h3 className="font-heading font-bold text-navy text-base" data-id="element-33">
        2. Uso de la Información
      </h3>
      <p data-id="element-34">
        Utilizamos tu información personal para: procesar tu compra y entregarte
        el producto digital, enviarte actualizaciones relacionadas con tu
        compra, mejorar nuestros productos y servicios, y cumplir con
        obligaciones legales aplicables.
      </p>

      <h3 className="font-heading font-bold text-navy text-base" data-id="element-35">
        3. Protección de Datos
      </h3>
      <p data-id="element-36">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado,
        alteración, divulgación o destrucción. Utilizamos encriptación SSL para
        todas las transacciones.
      </p>

      <h3 className="font-heading font-bold text-navy text-base" data-id="element-37">
        4. Compartir Información
      </h3>
      <p data-id="element-38">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros. Esto no incluye terceros de confianza que nos asisten en la
        operación de nuestro sitio web o en la conducción de nuestro negocio,
        siempre que dichas partes acuerden mantener esta información
        confidencial.
      </p>

      <h3 className="font-heading font-bold text-navy text-base" data-id="element-39">5. Cookies</h3>
      <p data-id="element-40">
        Nuestro sitio web puede utilizar cookies para mejorar tu experiencia de
        navegación. Puedes configurar tu navegador para rechazar cookies, aunque
        esto podría afectar la funcionalidad del sitio.
      </p>

      <h3 className="font-heading font-bold text-navy text-base" data-id="element-41">
        6. Tus Derechos
      </h3>
      <p data-id="element-42">
        Tienes derecho a acceder, corregir o eliminar tu información personal.
        Para ejercer estos derechos, puedes contactarnos a través de los canales
        proporcionados en nuestro sitio web.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-xs text-gray-400" data-id="element-43">
        Última actualización: Febrero 2026
      </p>

      <h3 className="font-heading font-bold text-navy text-base" data-id="element-44">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-45">
        Al acceder y utilizar este sitio web y al adquirir nuestros productos
        digitales, aceptas estar sujeto a estos Términos y Condiciones. Si no
        estás de acuerdo con alguna parte de estos términos, no debes utilizar
        nuestros servicios.
      </p>

      <h3 className="font-heading font-bold text-navy text-base" data-id="element-46">
        2. Naturaleza del Producto
      </h3>
      <p data-id="element-47">
        "El Código del Crédito 750+" es un producto de educación financiera en
        formato digital. No somos una agencia de reparación de crédito, ni un
        despacho de abogados, ni ofrecemos asesoramiento legal o financiero
        personalizado. La información proporcionada es de carácter educativo y
        general.
      </p>

      <h3 className="font-heading font-bold text-navy text-base" data-id="element-48">
        3. Resultados
      </h3>
      <p data-id="element-49">
        Los resultados pueden variar de persona a persona. Los testimonios y
        ejemplos presentados no garantizan que obtendrás los mismos resultados.
        Tu éxito depende de múltiples factores, incluyendo tu situación
        financiera actual, tu dedicación y las acciones que tomes.
      </p>

      <h3 className="font-heading font-bold text-navy text-base" data-id="element-50">
        4. Propiedad Intelectual
      </h3>
      <p data-id="element-51">
        Todo el contenido del producto, incluyendo textos, plantillas, guías y
        materiales, está protegido por derechos de autor. Queda prohibida la
        reproducción, distribución o reventa del material sin autorización
        expresa por escrito.
      </p>

      <h3 className="font-heading font-bold text-navy text-base" data-id="element-52">
        5. Política de Reembolso
      </h3>
      <p data-id="element-53">
        Debido a la naturaleza digital del producto y su entrega inmediata,
        todas las ventas son finales. Sin embargo, nos comprometemos a resolver
        cualquier problema técnico relacionado con el acceso al producto.
      </p>

      <h3 className="font-heading font-bold text-navy text-base" data-id="element-54">
        6. Limitación de Responsabilidad
      </h3>
      <p data-id="element-55">
        No seremos responsables de ningún daño directo, indirecto, incidental o
        consecuente que resulte del uso o la incapacidad de usar nuestros
        productos o servicios. El uso de la información proporcionada es bajo tu
        propia responsabilidad.
      </p>

      <h3 className="font-heading font-bold text-navy text-base" data-id="element-56">
        7. Modificaciones
      </h3>
      <p data-id="element-57">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor inmediatamente después de
        su publicación en el sitio web.
      </p>
    </>;
}